var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-white text-3xl font-base"},[_c('div',[_vm._v(_vm._s(_vm.$t('Joining as a participant'))+"?")]),_c('div',[_vm._v(_vm._s(_vm.$t('No account needed.')))])]),_c('vs-row',{staticClass:"mt-3",attrs:{"vs-type":"flex","vs-justify":"flex-start"}},[_c('form-enter-input-code')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }